import type { FormData } from '../form-datas/form-data'
import type { FormTemplateItem } from './form-template-item'
import type { FormTemplateTypeEnum } from './form-template-item-type.enum'

export class FormTemplate {
    formTemplateId: string
    companyId: string
    title: string
    form: FormTemplateItem[] = []
    status: number
    paged: number
    createdAt: string | Date
    updatedAt: string | Date
    formData?: FormData[]
    appearence?: string
    requiredFields?: string[]
    system: boolean
    showHeaders?: boolean
    type: FormTemplateTypeEnum
}
